export const spacesToHyphens = (text: string): string => {
  return text.replace(/\s+/g, '-')
}
